import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Credentials } from '../../../interfaces/credentials';
import { UserIface } from '../../../interfaces/user.iface';
import { CookieService } from 'ng2-cookies';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { LoggerService } from '../../../services/logger.service';
import { AuthQrantTypeEnum } from '../../../enums/authQrantType.enum';
import { EventsService } from '../../../services/events.service';
import { UserModel } from '../../../models/user.model';
import { filter } from 'rxjs/operators';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
  selector: 'app-authorization-form',
  templateUrl: './authorization-form.component.html',
  styleUrls: ['./authorization-form.component.scss']
})
export class AuthorizationFormComponent {
  @Input()
  public qrantType: string;
  public authorizationForm: FormGroup;
  public qrantTypeEnum = AuthQrantTypeEnum;
  public validationMessage: string;
  isSubmitting = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastsManager,
    private cookieService: CookieService,
    private events: EventsService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    this.authorizationForm = new FormGroup({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    });
  }

  signIn(form: FormGroup): void {
    this.isSubmitting = true;

    this.recaptchaV3Service.execute('importantAction').subscribe(recaptchaToken => {
      const credentials = new Credentials(form.value.username, form.value.password, this.qrantType, recaptchaToken);
      this.authService
        .signIn(credentials)
        .pipe(
          filter((res: UserIface) => {
            this.validationMessage = res.isBlocked ? 'Konto jest zablokowane. Skontaktuj się z administratorem' : null;
            return !res.isBlocked;
          })
        )
        .subscribe(
          (res: UserIface) => {
            const { token, ...user } = res;
            this.authService.token = token;
            this.cookieService.set('token', token);
            this.authService.user = user;
            this.router.navigate(['offers']);
            this.sendUserInfoEvent(new UserModel(user));
            this.isSubmitting = false;
          },
          err => {
            LoggerService.log('AuthorizationFormComponent::singIn', JSON.stringify(err));
            this.isSubmitting = false;

            if (err.status === 409) {
              this.toastr.error('Hasło wygasło! Zmień hasło.');
            } else {
              if (err.status === 405) {
                this.validationMessage = 'Konto jest zablokowane. Skontaktuj się z administratorem';
              } else if (err.status === 403) {
                this.validationMessage = null;
                this.toastr.error('Błędny login lub hasło!');
              } else if (err.status === 400) {
                this.validationMessage = null;
                this.toastr.error('Weryfikacja tokenu captcha nie powiodła się!');
              }
            }
          }
        );
    });
  }

  sendUserInfoEvent(user: UserModel): void {
    this.authService.getIpAddress().subscribe(
      data => {
        const event = this.events.getFetchUserEvent(user, data.ip);
        this.events.createEvent(event).subscribe();
      },
      err => {
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/authorization-form/authorization-form.component.ts